class FormTransformer {
  registerFormRef (formRef) {
    this.formRef = formRef
  }

  changeBottomPaddingPx (padding) {
    if (!this.formRef) return
    const paddingBottom = padding ? `${padding}px` : null
    this.formRef.style.paddingBottom = paddingBottom
  }
}

export default new FormTransformer()
